module.exports = __webpack_public_path__ + "assets/img/1january_dark.a26deb93.jpeg";